'use client'

import dynamic from 'next/dynamic'
import Image from 'next/image'
import { Avatar } from '@mui/material'

// Types
import type { AvatarItemProps } from '@/types/components/atoms/item/avatar'

// Components
const UserIconAtom = dynamic(() => import('@/components/atoms/icon/two-tone/user'))

const AvatarItemAtom = (props: AvatarItemProps) => {
	// Props
	const { name, src, size, isLocal } = props

	// Variables
	const firstLetter = name?.charAt(0).toUpperCase()
	const px = size === 'large' ? 100 : size === 'medium' ? 72 : 56

	return (
		<Avatar
			// Local images go through next/image, which resizes them and serves AVIF instead of the full file
			src={src && !isLocal ? `/api/download/${src}` : undefined}
			alt={name}
			sx={{
				width: 56,
				height: 56,
				...(size === 'medium' && { width: 72, height: 72 }),
				...(size === 'large' && { width: 100, height: 100 }),
				fontSize: 24,
				fontWeight: 700,
				color: 'primary.contrastText',
				bgcolor: 'primary.main'
			}}
		>
			{src && isLocal ? (
				<Image src={src} alt={name ?? ''} width={px} height={px} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
			) : (
				firstLetter || <UserIconAtom sx={{ fontSize: 32 }} />
			)}
		</Avatar>
	)
}

export default AvatarItemAtom
